import { useEffect } from 'react';

import {
	useSubscriptionsContext,
	useSubscriptionsDispatchContext,
	markErrorAsHandled,
} from '@confluence/graphql';
import { getMonitoringClient } from '@confluence/monitoring';
import { Attribution } from '@confluence/error-boundary';

export const CoverPictureUpdatedSubscription = ({
	onDataReceived,
	skip = false,
	contentId,
	contentType,
}: {
	onDataReceived: (value: any, version: any) => void;
	skip?: boolean;
	contentId?: string | null;
	contentType?: string | null;
}) => {
	const response = useSubscriptionsContext();
	const dispatch = useSubscriptionsDispatchContext();
	const { setContentId, setContentType, addSubscriber, removeSubscriber } = dispatch || {};
	useEffect(() => {
		if (skip || !dispatch || !contentId || !contentType) {
			return;
		}
		setContentId?.(contentId);
		setContentType?.(contentType);
		addSubscriber?.('coverPictureUpdated');
		return () => {
			removeSubscriber?.('coverPictureUpdated');
		};
	}, [
		skip,
		dispatch,
		contentId,
		contentType,
		setContentId,
		setContentType,
		addSubscriber,
		removeSubscriber,
	]);

	useEffect(() => {
		const onCoverPictureUpdatedSubscriptionData = () => {
			const data = response?.contentModified;
			const _deltas = data?._deltas;
			if (!data || !Array.isArray(_deltas)) {
				return;
			}
			if (_deltas?.length === 0 || _deltas.indexOf('coverPictureUpdated') === -1) {
				return;
			}

			const { coverPictureUpdated } = data;
			try {
				const value = JSON.parse(coverPictureUpdated?.value);
				const version = coverPictureUpdated?.version;
				onDataReceived(value, version);
			} catch (error) {
				getMonitoringClient().submitError(error, {
					attribution: Attribution.PAGE_EXPERIENCES,
				});
				markErrorAsHandled(error);
			}
		};
		!skip && onCoverPictureUpdatedSubscriptionData();
	}, [skip, response, onDataReceived]);

	return null;
};
